import axios from 'axios';
import swal from 'sweetalert';

const baseUrl = () => `${process.env.REACT_APP_BASE_URL}/airlinePromotionCode`;

const jsonHeaders = {
    headers: {
        'Content-type': 'application/json',
    },
};

export const postAirlineSearchByCriteria = async (
    payload: Record<string, any>,
    setterFunction: any,
    options?: { limit?: number; offset?: number },
) => {
    const limit = options?.limit ?? 100;
    const offset = options?.offset ?? 0;
    const body = { ...payload, limit, offset };
    try {
        const response: any = await axios.post(`${baseUrl()}/searchByCriteria`, body, jsonHeaders);
        if (response?.error) {
            swal({
                text: 'Fetching Failed!',
                icon: 'error',
            });
        }
        return response?.data;
    } catch (error) {
        console.error(error);
        setterFunction(false);
        swal({
            text: 'Failed',
            icon: 'error',
        });
        return [];
    }
};

export const fetchAirlinePromotionById = async (id: string | number, setterFunction?: any) => {
    try {
        const response = await axios.get(`${baseUrl()}?id=${id}`, jsonHeaders);
        if (response?.data?.msg === 'No records found.') {
            return null;
        }
        return response?.data;
    } catch (error) {
        console.error(error);
        if (setterFunction) setterFunction(false);
        swal({
            text: 'Failed',
            icon: 'error',
        });
        return null;
    }
};

export const createAirlinePromotion = async (payload: Record<string, any>) => {
    try {
        const response = await axios.post(`${baseUrl()}/`, payload, jsonHeaders);
        if (response?.data?.msg === 'success') {
            swal({
                text: 'Promotion updated successfully!',
                icon: 'success',
                buttons: {
                    close: {
                        text: 'Close',
                        closeModal: true,
                    },
                },
            });
        } else if (response?.data?.msg) {
            swal({
                text: response.data.msg,
                icon: 'error',
                buttons: {
                    close: {
                        text: 'Close',
                        closeModal: true,
                    },
                },
            });
        }
        return response?.data;
    } catch (error) {
        console.error(error);
        swal({
            text: 'Failed',
            icon: 'error',
        });
        throw error;
    }
};

export const updateAirlinePromotion = async (id: string | number, payload: Record<string, any>) => {
    try {
        const response = await axios.put(`${baseUrl()}?id=${id}`, payload, jsonHeaders);
        if (response?.data?.msg === 'No records found.') {
            swal({
                text: 'No records found.',
                icon: 'error',
            });
            return response?.data;
        }
        if (response?.data?.msg === 'success') {
            swal({
                text: 'Promotion updated successfully!',
                icon: 'success',
                buttons: {
                    close: {
                        text: 'Close',
                        closeModal: true,
                    },
                },
            });
        }
        return response?.data;
    } catch (error) {
        console.error(error);
        swal({
            text: 'Failed',
            icon: 'error',
        });
        throw error;
    }
};

export const deleteAirlinePromotion = async (id: string | number) => {
    try {
        const response = await axios.delete(`${baseUrl()}?id=${id}`, jsonHeaders);
        if (response?.data?.msg === 'No records found.') {
            swal({
                text: 'No records found.',
                icon: 'error',
            });
            return response?.data;
        }
        if (response?.data?.msg === 'success') {
            swal({
                text: 'Promotion deleted successfully!',
                icon: 'success',
                buttons: {
                    close: {
                        text: 'Close',
                        closeModal: true,
                    },
                },
            });
        }
        return response?.data;
    } catch (error) {
        console.error(error);
        swal({
            text: 'Failed',
            icon: 'error',
        });
        throw error;
    }
};
